import { cn } from "@/lib/utils";
import { Trash } from "iconsax-react";
import React, { FC, useEffect, useState } from "react";

interface Props {
  resource: string;
  index: number;
  setResources: React.Dispatch<React.SetStateAction<string[]>>;
  resources: string[];
  formError: any;
  generalFormError: any;
  setGeneralFormError: React.Dispatch<React.SetStateAction<any>>;
}

const AssignedResourceItem: FC<Props> = ({
  formError,
  generalFormError,
  index,
  resource,
  setGeneralFormError,
  setResources,
  resources,
}) => {
  const [isInputFocused, setIsInputFocused] = useState(false);

  useEffect(() => {}, []);

  const removeResource = () => {
    // @ts-ignore: Unreachable code error
    setResources(resources.filter((item, i) => i !== index));
    if (generalFormError?.resourcesErrors) {
      const updatedErrors = generalFormError.resourcesErrors.filter(
        (error: any) => error.index !== index,
      );
      setGeneralFormError({
        ...generalFormError,
        resourcesErrors: updatedErrors,
      });
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const auxSubsectors = [...resources];
    auxSubsectors[index] = event.target.value;
    setResources(auxSubsectors);

    if (generalFormError?.resourcesErrors) {
      const updatedErrors = generalFormError.resourcesErrors.filter(
        (error: any) => error.index !== index,
      );
      setGeneralFormError({
        ...generalFormError,
        resourcesErrors: updatedErrors,
      });
    }
  };

  return (
    <div>
      <p className="mb-2 text-sm">Recurso {index + 1}</p>
      <div
        className={cn(
          "flex h-12 items-center gap-1 rounded-xl border bg-white pl-3 pr-1",
          {
            "border-[#262452]": isInputFocused,
            "border-[#A0ACBA]": !isInputFocused,
          },
          formError?.isEmpty && "border-red-500",
        )}
      >
        <input
          maxLength={100}
          value={resource}
          onFocus={() => setIsInputFocused(true)}
          onBlur={() => setIsInputFocused(false)}
          placeholder="Añade un recursos"
          className={cn(
            "flex flex-1 bg-background px-1 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          )}
          onChange={handleChange}
        />
        <div
          className="cursor-pointer rounded-full p-3 hover:bg-[rgba(155,155,155,0.1)]"
          onClick={removeResource}
        >
          <Trash size="18" color="#4F5D6D" />
        </div>
      </div>
      {formError?.isEmpty && (
        <p className="mt-2 text-xs text-red-500">
          El nombre del recurso es obligatorio
        </p>
      )}
    </div>
  );
};

export default AssignedResourceItem;
